<template>
  <v-footer dark height="auto" >
    <v-container class="pa-0">
      <v-layout justify-center row wrap>
        <NewsletterForm />
        <v-flex class="py-3 text-xs-center secondary--text" xs12 >
          <template v-for="(menu,i) in menus">
            <a class="white--text" :key="i+menu.text" :href="_getRouteUrl(menu.link)" target="_blank">{{menu.text}}</a>
              <span v-if="i+1 < menus.length" :key="i" class="px-2">|</span>
          </template>
          <v-divider class="my-2"></v-divider>
          <div>
            &copy;{{moment()
            .format('YYYY')
            }} —
            {{$t('screener.powered_by.text')}}
            <a
              href="https://movieseverywhere.net"
              target="_blank"
            >
              <strong class="primary--text" v-html="$t('rms.footer.powered_by')"></strong>
            </a>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
import i18n from "@/i18n";
import NewsletterForm from "@/components/NewsletterForm"

export default {
  name: "AppFooter",
  data: () => ({
    menus: [
       {
          slug: "about",
          text: i18n.t("page.about"),
          link: "company.about"
        },
        {
          slug: "privacy",
          text: i18n.t("page.privacy"),
          link: "company.privacy"
        },
        {
          slug: "terms",
          text: i18n.t("page.terms"),
          link: "company.terms"
        }
    ]
  }),
  components:{NewsletterForm},
  methods:{
    _getRouteUrl(routeName, params={}){
      if(!routeName) return;
      const route = this.$router.resolve({ name: routeName, params: params })
      return route.href;
    }
  }
};
</script>

<style>
</style>
